<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form
            action=""
            method="post"
            enctype="multipart/form-data"
            class="form-horizontal"
        >
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Criterio</label
                >
                <div class="col-md-9">
                    <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        placeholder="ingrese un criterio de evaluacion"
                    />
                    <span v-if="allerrors.name" :class="['show-error']">{{
                        allerrors.name[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input">
                    Métricas
                </label>
                <div class="col-md-9">
                    <div class="form-group row">
                        <label
                            class="col-md-2 form-control-label"
                            for="text-input"
                            >Valor</label
                        >
                        <label
                            class="col-md-5 form-control-label"
                            for="text-input"
                            >Métrica</label
                        >
                    </div>
                    <div v-for="(value, index) in metrics" :key="index">
                        <div class="form-group row align-items-start">
                            <div class="col-md-2">
                                <input
                                    class="form-control"
                                    type="number"
                                    v-model.number="value.forValue"
                                    min="0"
                                    max="5"
                                    placeholder="0-5"
                                />
                                <span
                                    v-if="allerrors.metricsErrors && allerrors.metricsErrors[index]"
                                    class="show-error"
                                >{{ allerrors.metricsErrors[index] }}</span>
                            </div>
                            <input
                                class="form-control col-md-5"
                                type="text"
                                v-model="value.name"
                                placeholder
                            />
                        </div>
                    </div>
                    <div class="form-group row mt-2">
                        <div class="col-md-6">
                            <button
                                type="button"
                                @click="addMetric()"
                                class="btn btn-outline-success btn-sm mr-2"
                            >
                                + Agregar métrica
                            </button>
                            <button
                                type="button"
                                @click="removeMetric()"
                                class="btn btn-outline-danger btn-sm"
                                :disabled="metrics.length <= 1"
                            >
                                - Quitar métrica
                            </button>
                        </div>
                    </div>
                    <div v-if="allerrors.metrics2">
                        <span
                            v-for="(value, key, index) in allerrors.metrics2"
                            :key="index"
                            :class="['text-danger']"
                            >{{ value[0] }} <br />
                        </span>
                    </div>
                    <span v-if="allerrors.metrics" :class="['text-danger']">{{
                        allerrors.metrics[0]
                    }}</span>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Crear
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            name: null,
            metrics: [
                { name: "", forValue: 1 },
                { name: "", forValue: 2 },
                { name: "", forValue: 3 },
                { name: "", forValue: 4 },
                { name: "", forValue: 5 },
            ],
            allerrors: {
                name: null,
                metrics: null,
                metricsErrors: [],
            },
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contests/question-criteria/show/" + me.model_id)
                .then(function (response) {
                    me.name = response.data.model.name;
                    me.metrics = response.data.model.metrics != null
                        ? response.data.model.metrics
                        : [
                            { name: "", forValue: 1 },
                            { name: "", forValue: 2 },
                            { name: "", forValue: 3 },
                            { name: "", forValue: 4 },
                            { name: "", forValue: 5 },
                        ];
                })
                .catch(function () {});
        },
        create() {
            let me = this;
            const authUserId = document.querySelector(
                'meta[name="x-user"]'
            ).content;
            if (me.validForm()) {
                axios
                    .post(
                        `/api/contests/question-criteria?contest_id=${me.parent_id}&key=${authUserId}`,
                        {
                            name: me.name,
                            metrics: me.metrics,
                        }
                    )
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Creacion exitosa!");
                        me.$emit("change");
                    })
                    .catch(function (error) {
                        if (
                            error.response &&
                            error.response.data &&
                            error.response.data.errors
                        ) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        update() {
            let me = this;
            if (me.validForm()) {
                axios
                    .put(
                        "/api/contests/question-criteria/update/" + me.model_id,
                        {
                            name: me.name,
                            metrics: me.metrics,
                            contest_id: me.parent_id,
                        }
                    )
                    .then(function (response) {
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                        me.name = response.data.model.name;
                    })
                    .catch(function (error) {
                        if (error.response && error.response.data) {
                            me.allerrors = error.response.data.errors;
                        }
                    });
            }
        },
        addMetric() {
            const nextValue = this.metrics.length + 1;
            this.metrics.push({ name: "", forValue: nextValue });
        },
        removeMetric() {
            if (this.metrics.length > 1) {
                this.metrics.pop();
            }
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.name) {
                me.allerrors.name = ["El campo nombre es obligatorio."];
                valid = false;
            } else if (me.name.length > 190) {
                me.allerrors.name = ["El campo nombre debe tener máximo 190 caracteres"];
                valid = false;
            } else {
                me.allerrors.name = null;
            }

            me.allerrors.metricsErrors = me.metrics.map((m) => {
                if (m.forValue === null || m.forValue === "") {
                    valid = false;
                    return "El valor es obligatorio.";
                } else if (m.forValue < 0) {
                    valid = false;
                    return "El valor no puede ser menor a 0.";
                } else if (m.forValue > 5) {
                    valid = false;
                    return "El valor no puede ser mayor a 5.";
                }
                return null;
            });

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                name: null,
                metrics: null,
                metricsErrors: [],
            };
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        if (this.model_id > 0) {
            this.getModel();
        }
        return this.model_id;
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
